import { useState } from "react";
import { Share2 } from "lucide-react";
import { ShareSheet } from "./ShareSheet";
import { useFloatingControlVisible, useModalRegistration } from "@/lib/mobileFloatingControls";
import { useDraggableFab } from "@/lib/pr27/draggableFab";
import { recordWarRoomEvent } from "@/lib/warRoom/warRoomEngine";
import { bumpMission } from "@/lib/ambassadors/ambassadorEngine";
import { useMounted } from "@/hooks/useMounted";

export function ShareButton() {
  const [open, setOpen] = useState(false);
  const visible = useFloatingControlVisible("share_fab");
  useModalRegistration(open, "share_sheet");
  const drag = useDraggableFab("share_fab");
  const mounted = useMounted();
  // FAB visibility depends on viewport / tracking-engine state that only
  // exists in the browser. Render the hidden state during SSR / first
  // hydrate, then reveal post-mount to avoid SSR↔client divergence.
  const isVisible = mounted && visible;
  return (
    <>
      <button
        ref={drag.ref}
        onPointerDown={drag.onPointerDown}
        onClick={() => {
          if (!drag.isDragging) {
            setOpen(true);
            recordWarRoomEvent("shares");
            bumpMission("invite_5");
          }
        }}
        style={{ ...drag.style, width: 56, height: 56, borderRadius: 999, userSelect: "none" }}
        aria-label="Compartir"
        aria-hidden={!isVisible}
        className={
          "fixed right-4 z-30 hidden shrink-0 items-center justify-center rounded-full glass border border-border/60 backdrop-blur transition active:scale-95 lg:bottom-24 lg:right-6 lg:flex " +
          (isVisible ? "opacity-100" : "pointer-events-none opacity-0")
        }
      >
        <Share2 className="h-5 w-5 text-primary" />
      </button>
      <ShareSheet open={open} onClose={() => setOpen(false)} />
    </>
  );
}
